import React from "react";
import logo from "../logo/Logo.png";
import { Link } from "react-router-dom";


const AccountDeletion = ({ show, handleClose }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
            <Link to="/" className="no-underline group relative inline-block h-[40px] w-[200px]">
                                        <img src={logo} alt="logo" className="h-[40px]" />
                                        <span className="absolute top-1/2 ml-4 mt-1 transform -translate-y-1/2 text-xl font-bold text-green-700 pointer-events-none">
                                          manaChoice
                                        </span>
                                    </Link>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            &times;
          </button>
        </div>

        <div className="px-6 py-4 text-gray-600">
          account delition
        </div>

        <div className="flex justify-end px-6 py-4 border-t border-gray-200 space-x-3">
          <button
            onClick={handleClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleClose}
            className="px-4 py-2 text-sm font-medium text-white bg-green-500 rounded hover:bg-green-600"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletion;
